import React, { useEffect, useState } from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import AlarmSummaryFooter from './AlarmSummaryFooter';
import { ALM_SMM_DAT } from '../../molecules/Grid/AlarmGrid';
import { useModal } from '../../../function/useModal';
import ImageDialog, { ImageDialogResponse } from '../../molecules/Dialog/ImageDialog';
import AlarmSummaryGrid, { AlarmDatas } from './AlarmSummaryGrid';
import Grid, { GridSpacing } from '@material-ui/core/Grid';

type AlarmSummaryProps = {};

type ImageResponse = {
  Filepath: string;
};

type UpdateCheckResponse = {
  COL_DATE: Date;
  DEV_NO: string;
  DEV_NAME: string;
  ITM_NAME: string;
  JUDGE_NO: Number;
};

const useStyles = makeStyles(
  createStyles({
    tableContainer: {
      maxHeight: 'calc(100vh - 278px)',
      overflowY: 'scroll',
    },
  })
);

const AlarmSummaryPage: React.FC<AlarmSummaryProps> = (props: AlarmSummaryProps) => {
  const classes = useStyles();
  console.log('== AlarmSummary ==');
  const [alarmArray, setAlarmArray] = useState<AlarmDatas>();
  const [selIdx, setSelIdx] = useState<number>(0);
  const [noCheckCount, setNoCheckCount] = useState<number>(0);
  const [flgDlg, actDlg] = useModal<ImageDialogResponse>();
  const [imgPath, setImgPath] = useState<string>('');

  const getData = () => {
    fetch('api/AlarmSummary')
      .then((res) => res.json())
      .then(
        (result: AlarmDatas) => {
          console.debug(['result', result]);
          result.forEach((item, idx) => {
            item.rowno = idx + 1;
          });
          setAlarmArray(result);
          setNoCheckCount(result.filter((item) => !item.ALM_SMM_DAT.CHECKED).length);
        },
        (error) => {
          console.log(error);
        }
      );
  };

  useEffect(() => {
    getData();
  }, []);

  const dlg = flgDlg ? (
    <ImageDialog dialog={actDlg} imagePath={imgPath} imageWidht={'100%'} imageHeigth={'100%'} title={imgPath} />
  ) : null;

  // 三次元グラフ表示
  const graphButtonAction = () => {
    console.log();
    // ファイル名を取得するAPIを呼び出し
    if (alarmArray) {
      const dt: ALM_SMM_DAT | undefined = alarmArray.find((item) => item.rowno === selIdx)?.ALM_SMM_DAT;
      if (dt) {
        var url = `api/AlarmSummary/${dt.PLC_NO}/${dt.AI_CARD}/${dt.AI_CH}/${dt.DEV_NO}/${dt.DEV_NAME}/${dt.ITM_NAME}/${dt.COL_DATE}`;
        fetch(url)
          .then((res) => res.json())
          .then((result: ImageResponse) => {
            console.log(result);
            setImgPath(result.Filepath);
            actDlg
              .open()
              .apply((resp: ImageDialogResponse) => {})
              .cancel(() => {});
          });
      }
    }
  };
  // 一括確認
  const bulkButtonAction = () => {
    if (alarmArray) {
      // 状態更新処理呼び出し
      fetch('api/AlarmSummary/BulkUpdate', {
        method: 'post',
      })
        .then((resp) => {
          console.log(resp);
          getData();
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
  // 削除
  const deleteButtonAction = () => {
    if (alarmArray) {
      const deleteTarget: ALM_SMM_DAT | undefined = alarmArray.find((item) => item.rowno === selIdx)?.ALM_SMM_DAT;
      if (deleteTarget) {
        // 削除処理呼び出し
        fetch('api/AlarmSummary/DeleteAlarm', {
          method: 'delete',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(deleteTarget),
        })
          .then((resp) => {
            getData();
            setSelIdx(0); // 選択をリセット
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }
  };

  return (
    <Grid container justify="flex-start" spacing={1} direction="row" alignItems="center" style={{ margin: 0 }}>
      <Grid item xs={12}>
        <AlarmSummaryGrid
          alarmArray={alarmArray}
          alarmContainerStyle={classes.tableContainer}
          selectIndex={selIdx}
          setSelectIndex={setSelIdx}
        />
      </Grid>
      <Grid item xs={12}>
        <AlarmSummaryFooter
          graphButton={graphButtonAction}
          bulkButton={bulkButtonAction}
          deleteButton={deleteButtonAction}
          count={noCheckCount}
        />
      </Grid>
      {dlg}
    </Grid>
  );
};

export default AlarmSummaryPage;
